import React from 'react';
import {
  ProgressContainer,
  ProgressBar,
  ProgressIndicator,
  ProgressText,
} from './CharacterStyles';

interface ProgressIndicatorProps {
  currentStep: number;
  totalGroups: number;
  progress: number;
  currentGroupLabel?: string;
}

const ProgressIndicatorComponent: React.FC<ProgressIndicatorProps> = ({
  currentStep,
  totalGroups,
  progress,
  currentGroupLabel,
}) => {
  return (
    <ProgressContainer>
      <ProgressBar>
        <ProgressIndicator progress={progress} />
      </ProgressBar>
      <ProgressText>
        <span>
          Step {currentStep + 1} of {totalGroups}
        </span>
        <span>{': ' + currentGroupLabel}</span>
      </ProgressText>
    </ProgressContainer>
  );
};

export default ProgressIndicatorComponent;
